import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const connectionSchema: Schema = {
  title: 'Connections',
  level: 1,
  columns: commonColumns
}
